import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import MaintenanceProjectList from './MaintenanceProjectList';
import ServiceItemsView from './ServiceItemsView';
import ErrorBoundary from '@/components/ErrorBoundary';
import type { MaintenanceFiltersData } from '@/hooks/maintenance/useMaintenanceFiltersState';

interface ServiceTabProps {
  activeTab: 'mt-projects' | 'all-plan';
  onTabChange: (tab: 'mt-projects' | 'all-plan') => void;
  filters: MaintenanceFiltersData;
  onFiltersChange: (filters: MaintenanceFiltersData) => void;
  currentPage: number;
  onPageChange: (page: number) => void;
}

const ServiceTab = ({ 
  activeTab, 
  onTabChange, 
  filters, 
  onFiltersChange,
  currentPage,
  onPageChange 
}: ServiceTabProps) => {
  return (
    <Tabs 
      value={activeTab} 
      onValueChange={(val) => onTabChange(val as 'mt-projects' | 'all-plan')} 
      className="w-full"
    >
      <TabsList className="grid w-full grid-cols-2 lg:w-[600px]">
        <TabsTrigger value="mt-projects">MT Projects</TabsTrigger>
        <TabsTrigger value="all-plan">Service Plan</TabsTrigger>
      </TabsList>
      
      <TabsContent value="mt-projects" className="mt-6">
        <MaintenanceProjectList 
          filters={filters}
          onFiltersChange={onFiltersChange}
          currentPage={currentPage}
          onPageChange={onPageChange}
        />
      </TabsContent>
      
      <TabsContent value="all-plan" className="mt-6">
        <ErrorBoundary fallback={
          <div className="flex items-center justify-center p-8">
            <div className="text-center space-y-2">
              <p className="text-destructive">Service Plan tab crashed</p>
              <p className="text-muted-foreground text-sm">Please refresh the page</p>
            </div>
          </div>
        }>
          <ServiceItemsView />
        </ErrorBoundary>
      </TabsContent>
    </Tabs>
  );
};

export default ServiceTab;
